module.exports = __webpack_public_path__ + "f9f45ce33d2e888e9693ecdd313137a9.png";